var _defs, _g, _rect, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWholesaleOrder3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.03,141.46h75.67c1.96,0,3.7-1.22,4.37-3.06l19.75-54.41c1.53-4.05-1.47-8.38-5.8-8.38H88.02l24.01,65.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.12,158.83H111.34c-4.8,0-8.69-3.89-8.69-8.69h0c0-4.8,3.89-8.69,8.69-8.69h76.53"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 128.35,
    cy: 168.06,
    r: 9.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.34,
    cy: 168.06,
    r: 9.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.17,141.46L77.12,46.46c-.12-.33-.43-.54-.78-.54h-23.04"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 150.12,
    y1: 97.23,
    x2: 150.12,
    y2: 119.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 138.82,
    y1: 108.54,
    x2: 161.43,
    y2: 108.54
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.81,
    y: 42.6,
    width: 30.96,
    height: 8.5,
    rx: 3.8,
    ry: 3.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.89,
    y: 172.72,
    width: 126.22,
    height: 66.2,
    rx: 12.99,
    ry: 12.99
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 222.24,
    y: 172.72,
    width: 66.2,
    height: 66.2,
    rx: 12.99,
    ry: 12.99
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 255.34,
    y1: 190.58,
    x2: 255.34,
    y2: 221.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 240.1,
    y1: 205.82,
    x2: 270.58,
    y2: 205.82
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.56,
    y: 172.72,
    width: 66.2,
    height: 66.2,
    rx: 12.99,
    ry: 12.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 29.42,
    y1: 205.82,
    x2: 59.9,
    y2: 205.82
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 150,
    cy: 205.82,
    r: 44.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "128.76 206.67 142.35 220.26 171.24 191.38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesaleOrder3);
export default __webpack_public_path__ + "static/media/wholesale_order_3.68979aff6b4b602fd7b27a20ec2b33bc.svg";
export { ForwardRef as ReactComponent };